<template>
  <v-container fluid>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
    <v-card class="card--flex-toolbar">
      <v-toolbar color="grey lighten-4" class="elevation-0" tabs>
        <v-toolbar-title>Permissões para: {{ user}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="active" style="min-height:350px">
          <v-tab-item key="1">
            <!-- BLOQUEIO ATIVIDADE -->
            <v-layout column style="height: 320px">
              <v-flex style="overflow: auto">
                <v-data-table
                  v-model="permissoes"
                  :headers="headersPermissoes"
                  :items="permissoesItens"
                  item-key="programa"
                  :rows-per-page-items="[1000]"
                  hide-actions
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.programa }}</td>
                    <td width="20px">
                      <v-checkbox v-model="props.item.acessar" primary hide-details></v-checkbox>
                    </td>
                    <td width="20px">
                      <v-checkbox v-model="props.item.incluir" primary hide-details></v-checkbox>
                    </td>
                    <td width="20px">
                      <v-checkbox v-model="props.item.alterar" primary hide-details></v-checkbox>
                    </td>
                    <td width="20px">
                      <v-checkbox v-model="props.item.excluir" primary hide-details></v-checkbox>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn small color="primary" @click="$router.push('/permissoes')">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="salvar()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { showFlash, showError } from '@/utils'
import permissaoService from '@/services/permissao'
import programaService from '@/services/programa'

export default {
  name: 'associados',
  data () {
    return {
      search: '',
      permissoes: [],
      permissoesItens: [],
      user: '',
      headersPermissoes: [
        {
          text: 'Programa',
          align: 'left',
          sortable: false,
          value: 'programa'
        }, {
          text: 'Acessar',
          align: 'center',
          sortable: false,
          value: 'acessar'
        }, {
          text: 'Incluir',
          align: 'center',
          sortable: false,
          value: 'incluir'
        }, {
          text: 'Alterar',
          align: 'center',
          sortable: false,
          value: 'alterar'
        }, {
          text: 'Excluir',
          align: 'center',
          sortable: false,
          value: 'excluir'
        }],
      loading: false,
      valid: true,
      active: 0,
      modo: '',
      usuario: '',
      resultado: {}
    }
  },
  mounted: async function () {
    try {
      this.loading = true
      let programas = await programaService.getAll()
      let usuario = this.$route.params.nome
      this.user = this.$route.params.nome
      let niveis = await permissaoService.getByProgramaUsuario(usuario)
      this.permissoes = niveis.data
      // Para cada programa, verifica se possui acesso
      if (programas !== [] && niveis !== undefined) {
        programas.data.forEach(itemProgramas => {
          niveis.data.forEach(itemNiveis => {
            if (itemProgramas.nome === itemNiveis.programa) {
              this.permissoesItens.push(itemNiveis)
            }
          })
        })
      }
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  methods: {
    async salvar () {
      try {
        let perm = []
        let usu = this.$route.params.nome
        this.permissoesItens.forEach(item => {
          perm.push(
            {
              programa: item.programa,
              acessar: item.acessar,
              incluir: item.incluir,
              alterar: item.alterar,
              excluir: item.excluir,
              usuario: usu
            })
        })
        if (perm.length > 0) {
          await permissaoService.save(perm)
        }
        showFlash('Salvo com sucesso')
      } catch (error) {
        showError(error)
      }
    }
  }
}
</script>
